import React from 'react';

const EngagementMetricsCards = ({ metrics, loading }) => {
  const cards = [
    {
      label: 'KOMMENTARER POSTET',
      value: metrics?.totalComments ?? 0,
      sublabel: 'totalt',
      accent: '#3B6FD4',
      ghost: '01',
      rotate: '-1.5deg',
    },
    {
      label: 'LIKES MOTTATT',
      value: metrics?.totalLikes ?? 0,
      sublabel: 'på dine kommentarer',
      accent: '#E76F51',
      ghost: '02',
      rotate: '1deg',
    },
    {
      label: 'MEST POPULÆR',
      value: metrics?.topLikes ?? 0,
      sublabel: 'likes på én kommentar',
      accent: '#2EC4A0',
      ghost: '03',
      rotate: '-0.5deg',
    },
  ];

  return (
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: '24px', marginBottom: '48px' }}>
      {cards?.map((card, i) => (
        <div
          key={i}
          style={{
            background: 'rgba(255,255,255,0.02)',
            border: `2px solid ${card?.accent}44`,
            padding: '28px 24px',
            position: 'relative',
            transform: `rotate(${card?.rotate})`,
            overflow: 'hidden',
            transition: 'transform 0.2s ease',
            cursor: 'default',
          }}
          onMouseEnter={e => e.currentTarget.style.transform = 'rotate(0deg) scale(1.02)'}
          onMouseLeave={e => e.currentTarget.style.transform = `rotate(${card?.rotate})`}
        >
          {/* Ghost number */}
          <span style={{
            position: 'absolute', top: '-10px', right: '8px',
            fontFamily: 'Impact, sans-serif', fontSize: '5rem',
            color: `${card?.accent}12`, lineHeight: 1, userSelect: 'none', pointerEvents: 'none',
          }}>{card?.ghost}</span>

          {/* Color bar */}
          <div style={{ position: 'absolute', top: 0, left: 0, width: '4px', height: '100%', background: card?.accent }} />

          <div style={{ fontFamily: 'JetBrains Mono, monospace', fontSize: '0.6rem', letterSpacing: '0.2em', color: card?.accent, marginBottom: '12px', textTransform: 'uppercase' }}>
            {card?.label}
          </div>

          {loading ? (
            <div style={{ height: '60px', background: 'rgba(255,255,255,0.04)', animation: 'pulse 1.5s infinite' }} />
          ) : (
            <div style={{ fontFamily: 'Impact, sans-serif', fontSize: '3.5rem', color: '#EEF0F2', lineHeight: 1, marginBottom: '8px' }}>
              {card?.value?.toLocaleString('nb-NO')}
            </div>
          )}

          <div style={{ fontFamily: 'Georgia, serif', fontSize: '0.75rem', color: 'rgba(238,240,242,0.45)', fontStyle: 'italic' }}>
            {card?.sublabel}
          </div>
        </div>
      ))}
    </div>
  );
};

export default EngagementMetricsCards;
